import { useDroppable } from '@dnd-kit/core';
import { Box } from '@mui/material';

export const DroppableContainer = ({ id }: { id?: string }) => {
  const {
    setNodeRef,
    isOver: isDraggingOver,
    over: isDragging,
  } = useDroppable({
    id: id ?? 'droppable',
  });

  return (
    <Box
      data-testid="droppable-box"
      ref={setNodeRef}
      width="25px"
      height="65px"
      minWidth="48px"
      margin="8px 16px"
      border={isDragging ? '5px dashed rgba(155, 155, 155, 0.5)' : ''}
      borderColor={isDraggingOver ? 'white' : ''}
      borderRadius="16px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      boxSizing="border-box"
      flexGrow={1}
    />
  );
};
